"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRequest = void 0;
var ListRequest = /** @class */ (function () {
    function ListRequest() {
    }
    return ListRequest;
}());
exports.ListRequest = ListRequest;
;
//# sourceMappingURL=list.request.js.map